class LanguagesServicesService {
  static convertLanguagesInitList = (list) => {
    if (!Array.isArray(list)) return {};

    const modifiedList = list.reduce((acc, i) => ({
      ...acc,
      [i.locale]: {
        id: i.id,
        code: i.locale,
        name: i.name,
        shortName: i.locale[0].toUpperCase() + i.locale.slice(1),
      },
    }), {});

    return modifiedList;
  };
}

export default LanguagesServicesService;
